// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/obstacle-clearance-takeoff-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/obstacle-clearance-takeoff-technique/obstacle-clearance-takeoff-technique.js';

mount([g0]);
